/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkinflyerpreviewlabel3Inputs */

const en_checkinflyerpreviewlabel3 = /** @type {(inputs: Checkinflyerpreviewlabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview`)
};

const de_checkinflyerpreviewlabel3 = /** @type {(inputs: Checkinflyerpreviewlabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschau`)
};

/**
* | output |
* | --- |
* | "Preview" |
*
* @param {Checkinflyerpreviewlabel3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinflyerpreviewlabel3 = /** @type {((inputs?: Checkinflyerpreviewlabel3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinflyerpreviewlabel3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinflyerpreviewlabel3(inputs)
	return de_checkinflyerpreviewlabel3(inputs)
});
export { checkinflyerpreviewlabel3 as "checkinFlyerPreviewLabel" }